<div style="cursor: pointer">
  <div class="">
    <div class="row">

      <div class="col-md-12">
        <h3><i class="fas fa-sitemap"
            style="margin-right: 6px;color: rgb(202,1,1);font-size: 20px;"></i>{{sort_by}} <strong>Tree </strong>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div>
          <ul class="nav nav-tabs">
            <mat-progress-bar *ngIf=" show_progressbar==true" class="mt-1" mode="query"></mat-progress-bar>


            <li class="nav-item"><a role="tab" data-toggle="tab" href="#tab-1" (click)="get_ngx_tree(sort_by)"
                class="nav-link active" id="refreshID">Refresh</a></li>
            <hr>
          </ul>
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" id="tab-1">

              <div class="row shadow">

                <div class="col">



                  <ng-template #itemTemplate let-item="item" let-onCollapseExpand="onCollapseExpand"
                    let-onCheckedChange="onCheckedChange" >
                    <div  class="form-inline row-item">
                      <i *ngIf="item.children" class="mr-1" (click)="onCollapseExpand()" aria-hidden="true"
                        [ngSwitch]="item.collapsed">
                        <svg *ngSwitchCase="true" width="0.8rem" height="0.8rem" viewBox="0 0 16 16"
                          class="bi bi-caret-right-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                        </svg>
                        <svg *ngSwitchCase="false" width="0.8rem" height="0.8rem" viewBox="0 0 16 16"
                          class="bi bi-caret-down-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                        </svg>
                      </i>
                      <div [style]="node_click_style(item)" (click)="onSelection_new(item); set_node_click_style_value(item)" class="form-check">
                        <input type="checkbox" class="form-check-input" [(ngModel)]="item.checked"
                          (ngModelChange)="onCheckedChange()" [disabled]="item.disabled"
                          [indeterminate]="item.indeterminate" [disabled]="!has_checkbox"/>

                          <mat-icon *ngIf="item.value['type']=='folder'" aria-hidden="false" aria-label="Folder">folder</mat-icon>
                          <mat-icon *ngIf="item.value['type']=='endpoint'" aria-hidden="false" aria-label="Endpoint">videocam</mat-icon>
                          <mat-icon *ngIf="item.value['type']=='template'" aria-hidden="false" aria-label="Template">list</mat-icon>
                          <mat-icon *ngIf="item.value['type']=='template_job'" aria-hidden="false" aria-label="Template_Job">chrome_reader_mode</mat-icon>


                        <label class="form-check-label" >
                          {{ item.text }}
                        </label>
                      </div>
                    </div>
                  </ng-template>
                  <ngx-treeview [config]="config" [items]="items" [itemTemplate]="itemTemplate"
                    (filterChange)="onFilterChange($event)" (selectedChange)="onSelectedChange($event)">

                  </ngx-treeview>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>
